import { render, staticRenderFns } from "./goodlist.vue?vue&type=template&id=71b56402&scoped=true&"
import script from "./goodlist.vue?vue&type=script&lang=js&"
export * from "./goodlist.vue?vue&type=script&lang=js&"
import style0 from "./goodlist.vue?vue&type=style&index=0&id=71b56402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b56402",
  null
  
)

export default component.exports